import moment from 'moment';

// TODO: some of these hooks can probably be improved by using the useUserSchedule and useUserPotentialSchedule

import { useUpcomingSessions } from '../../data/hooks/schedule/useUpcomingSessions';
import { useSessionsInProgress } from '../../data/hooks/schedule/useSessionsInProgress';
import { SCHEDULE_SESSION_DISPLAY_TYPE_ONLINE } from 'common-data-handling';

const SORT_BY = [
    'start_utc',
    // selected sessions should appear first
    (session) => (session.is_selectable && session.is_selected ? -1 : 0),
    // sessions online have prevalence on networkarea (others should probably be left back but we may need to show the round)
    (session) =>
        session.display_type == SCHEDULE_SESSION_DISPLAY_TYPE_ONLINE ? -1 : 0,
    // sessions inside rounds are more important
    (session) => (session.round_id ? -1 : 0),
];

function isOfCorrectDisplayType(session) {
    return !['speeddate'].includes(session.display_type);
}

export const sidePanelSessionFilter = (session, filter = (o) => o) =>
    isOfCorrectDisplayType(session) &&
    (session.is_selected || !session.is_selectable) &&
    filter(session) &&
    !session.display_category;

export function useSessionInProgress(
    eventId,
    { filter = (o) => o, sortBy = SORT_BY } = {}
) {
    return useSessionsInProgress(eventId, {
        filter: (session) => sidePanelSessionFilter(session, filter),
        sortBy,
        count: 1,
    })[0];
}

export const sidePanelNextSessionFilter = (session, filter = (o) => o) =>
    filter(session) &&
    isOfCorrectDisplayType(session) &&
    moment().isSameOrBefore(session.start_utc) &&
    // moment(session.start_utc).valueOf() >= now.valueOf() &&
    (session.is_selected || !session.is_selectable) &&
    !session.display_category;

export function useNextSession(
    eventId,
    { filter, sortBy: orderBy = SORT_BY } = {}
) {
    let now = moment(),
        sessions = useUpcomingSessions(eventId, {
            filter: (session) => sidePanelNextSessionFilter(session, filter),
            orderBy,
        });

    return sessions[0];
}
